module.exports = __webpack_public_path__ + "static/media/andrews_logo.fa10c347.png";